// TODO: delete when new customize UI enabled for everyone
import { reaction } from 'mobx';
import PropTypes from 'prop-types';
import { apiCall } from '../API';
import FlagStore from './FlagStore';
import EntityFormStore from './helpers/EntityFormStore';
import TextStore from './helpers/TextStore';
import ValueStore from './helpers/ValueStore';

export default class ExitMessageStore extends EntityFormStore {
    static _PropType = {
        ...EntityFormStore._PropType,
        option: ValueStore.PropTypes,
        text: TextStore.PropTypes,
        pagePreviewToggle: FlagStore.PropTypes,
        modalPreviewToggle: FlagStore.PropTypes,
        isCustomMessageEditable: PropTypes.func,
    };

    static PropType = PropTypes.shape(ExitMessageStore._PropType);

    constructor(data = { }) {
        super({
            option: new ValueStore('DEFAULT'),
            text: new TextStore(),
        }, {
            apiLoad: apiCall('/console/exit_message/get'),
            apiUpdate: apiCall('/console/exit_message/update'),
            pagePreviewToggle: new FlagStore(true),
            modalPreviewToggle: new FlagStore(true),
            isCustomMessageEditable: () => this.option.equals('CUSTOM'),
        }, data);

        reaction(() => this.option.getValue(),
            (x) => (x === 'CUSTOM') && setTimeout(this.text.focus));
    }

    isValid = () => {
        return this.option.equals('DEFAULT') || !!this.text.getValue();
    };
}
